module.exports = __webpack_public_path__ + "static/media/galerija_2014 (11).1683d01a.jpg";